import MaintenanceDirectorySection, {
  MAINTENANCE_DIRECTORY_COLUMN_DEFS,
  createInitialMaintenanceColumnVisibility,
  maintenanceDefaultDirectoryFilters,
  maintenanceDirectoryCellValue,
} from "../../control/sections/MaintenanceDirectorySection";

export const OFFICE_MAINTENANCE_LIST_COLUMN_VISIBILITY_KEY =
  "girinestham.officeMaintenanceDirectory.columnVisibility";

export function createOfficeMaintenanceInitialColumnVisibility() {
  return createInitialMaintenanceColumnVisibility(OFFICE_MAINTENANCE_LIST_COLUMN_VISIBILITY_KEY);
}

export default function OfficeMaintenanceDirectorySection({ embedded = false, ...props }) {
  return (
    <MaintenanceDirectorySection
      {...props}
      embedded={embedded}
      sectionDomId="mr-list"
      columnVisibilityStorageKey={OFFICE_MAINTENANCE_LIST_COLUMN_VISIBILITY_KEY}
      directoryActionMode="office"
      directoryPaginationLabel="Office maintenance directory pagination"
      directoryPanelHint="Search by name, pick a column and value, adjust visible columns, and export when needed."
    />
  );
}

export {
  MAINTENANCE_DIRECTORY_COLUMN_DEFS,
  maintenanceDefaultDirectoryFilters,
  maintenanceDirectoryCellValue,
};
